import React from 'react';
import { Button } from 'semantic-ui-react';

import ButtonWrapper from './ButtonWrapper';
import { VIEW_MODE } from '../../constants';
import { momentParse } from 'react-lib/dist/dates-es';

class CurrentRemoveDateButtonsWrapper extends React.PureComponent {
  render() {
    const { disabled, mode, setDefaultDte, dteName, setFieldValue, id, buttonClassName } = this.props;
    return mode !== VIEW_MODE ? (
      <Button.Group className={`mini ${buttonClassName}`}>
        <ButtonWrapper
          id={id + 'DefaultDte'}
          type="button"
          icon="calendar"
          primary={true}
          className="inputDefaultButton"
          onClick={() => {
            setDefaultDte(false, dteName, setFieldValue);
          }}
          disabled={disabled}
        />
        <ButtonWrapper
          icon="remove"
          color="red"
          className="inputDefaultButton"
          onClick={() => setDefaultDte(true, dteName, setFieldValue)}
          disabled={disabled}
        />
      </Button.Group>
    ) : null;
  }
}

CurrentRemoveDateButtonsWrapper.defaultProps = {
  setDefaultDte: (clear, dteName, setFieldValue) => {
    setFieldValue(dteName, clear ? null : momentParse(new Date()));
  },
};

export default CurrentRemoveDateButtonsWrapper;
